<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp text-center" data-wow-delay="0.1s">
  <div class="container text-center">
    <div
      class="mb-5 wow mx-auto fadeInUp text-center"
      data-wow-delay="0.1s"
      style="max-width: 705px"
    >
      <p>
        {{ ADMISSION_DATA.briefText[this.language] }}
      </p>
    </div>
    <div class="row g-4 center-content">
      <div
        *ngFor="let item of ADMISSION_DATA.details"
        class="col-lg-6 col-md-6 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div class="classes-item">
          <div class="bg-light rounded-circle w-75 mx-auto p-5">
            <img
              class="img-fluid rounded-circle"
              src="../../../../assets/img/{{ item.image }}"
              alt=""
            />
          </div>
          <div class="bg-light rounded p-4 pt-5 mt-n5">
            <a class="d-block text-center h3 mt-3 mb-4">{{
              item.title[language]
            }}</a>
            <a
              class="btn btn-primary rounded-pill py-3 px-5"
              href="{{ item.url }}"
              >{{ "apply_now" | translate }}</a
            >
            <div class="row g-4 align-items-center">
              <div class="col-sm-6"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Page content end -->
